import Config from '@src/config/Config';

export enum DevFlag {
  DEV_WATERMARK = 'DEV_WATERMARK',
  PERMIT_MANAGER_AUTOFILL_EXTENSION = 'PERMIT_MANAGER_AUTOFILL_EXTENSION',
}

function toBoolean(value: string | undefined | boolean) {
  if (typeof value === 'boolean') {
    return value;
  }

  if (!value) {
    return false;
  }

  return Boolean(JSON.parse(value));
}

function parseDevFlag(flag: DevFlag) {
  const name = `VITE_DEV_FLAG_${flag}` as keyof typeof Config;
  const value = toBoolean(Config[name]) || false;

  return Boolean(value);
}

type DevFlagsConfiguration = {
  [flag in DevFlag]: boolean;
};

const createConfiguration = (): DevFlagsConfiguration => ({
  [DevFlag.DEV_WATERMARK]: parseDevFlag(DevFlag.DEV_WATERMARK),
  [DevFlag.PERMIT_MANAGER_AUTOFILL_EXTENSION]: parseDevFlag(
    DevFlag.PERMIT_MANAGER_AUTOFILL_EXTENSION,
  ),
});

export interface DevFlagSelect<T> {
  enabled: T;
  disabled: T;
}

const isEnabled = (devFlag: DevFlag): boolean => {
  return createConfiguration()[devFlag] || false;
};

const select = <T>(
  devFlag: DevFlag,
  { enabled, disabled }: DevFlagSelect<T>,
): T => {
  if (isEnabled(devFlag)) {
    return enabled;
  }

  return disabled;
};

export default {
  isEnabled,
  select,
};
